<template>
   <div class="barcodeScaleSetup">
        <div class="scroll-box">
            <div class="tr-li">
                <div class="from-input">
                    <el-checkbox v-model="isBarcodeScale" label="启用条码秤菜品识别功能"></el-checkbox>
                </div>
            </div>
            <div class="title">方式一:菜品编码+数里组合方式</div>
            <div class="tr-box">
                菜品编码从第 
                <el-input-number v-model="foodCodeStartIndex" :min="1" /> 
                开始，长度为 
                <el-input-number v-model="foodCodeLength" :min="1" />
            </div>
            <div class="tr-box">
                菜品数量从第 
                <el-input-number v-model="foodNumberStartIndex" :min="1" /> 
                开始，长度为 
                <el-input-number v-model="foodNumberLength" :min="1" />
                小数位占 <el-input-number v-model="foodDecimal" :min="0" :max="4" /> 位
            </div>
            <div class="tr-li">
                <div class="lable-txt" style="min-width: 75px;">设备IP地址:</div>
                <div class="from-input" style="width:200px"><input type="text" v-model="ip"></div>
                <div class="bnt-additem" @click="addItem">导入菜品到设备</div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn" @click="back();">返回</button>
            <button class="btn selected" @click="saveConfig()">保存配置</button>
        </div>
   </div>
</template>

<script>
export default {
    name:'barcodeScaleSetup',
    data(){
        return {
            //启用条码秤菜品识别功能
            isBarcodeScale:false,
            /**菜品编码从第 3 开始*/
            foodCodeStartIndex:3,
            /**菜品编码长度5 */
            foodCodeLength:5,
            /**菜品数量从第 8 开始，*/
            foodNumberStartIndex:8,
            /**长度为  */
            foodNumberLength:5,
            /**小数位占 */
            foodDecimal:0,
            ip:"192.168.1.252"
        }
    },
    mounted(){
        this.$webBrowser.getBarcodeScale().then(d=>{//获取电子秤配置信息
            if(d){
                this.ip=d.ip||"192.168.1.252";
                this.isBarcodeScale=d.isBarcodeScale==true;
                this.foodCodeStartIndex=d.foodCodeStartIndex||3;
                this.foodCodeLength=d.foodCodeLength||5;
                this.foodNumberStartIndex=d.foodNumberStartIndex||8;
                this.foodNumberLength=d.foodNumberLength||5;
                this.foodDecimal=d.foodDecimal||0;
            }
        });
    },
    methods:{
        /**退出 */
        back(){
            this.$emit("close");
        },
        /**同步菜品 */
        addItem(){
            if(!this.ip){
                this.$message.warning('请输入设备IP地址');
                return;
            }
            if(!/^(([1-9]?\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}([1-9]?\d|1\d{2}|2[0-4]\d|25[0-5])$/.test(this.ip)){
                this.$message.warning('设备IP地址格式不正确！');
                return;
            }

            const loading = this.$loading({
                text: "获取全部菜品数据中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$cacheData.AllPosFoods().then(food=>{
                
                let list=[],keys={};
                food?.forEach(main => {
                    main?.FoodSubCategorys?.forEach(sub=>{
                        sub?.PosFoods?.forEach(it=>{
                            if(!it.Is_SetMeal){//单菜
                                if(!keys[it.Food_Code]){//唯一
                                    keys[it.Food_Code]={
                                        plu:it.Third_Code,
                                        name1: it.Food_Name,
                                        code: it.Food_Code,
                                        price: it.Food_Price,
                                    };
                                    list.push(keys[it.Food_Code]);
                                }
                                
                                it.MultipleSizeFoods?.forEach(multip=>{//多单位
                                    if(!keys[multip.Food_Code]){//唯一
                                        keys[multip.Food_Code]={
                                            plu:it.Third_Code,
                                            name1: multip.Food_Name,
                                            code: multip.Food_Code,
                                            price: multip.Food_Price
                                        };
                                        list.push(keys[multip.Food_Code]);
                                    }
                                })
                            }
                        })
                    })
                });
                if(list.length>0){
                    this.$webBrowser.elsAddItem(this.ip,list).then(data=>{
                        loading.close();
                        if(data && (data.status==0 || data.state==0)){
                            this.$message.success("导入菜品库成功！共："+(list.length)+"/道!");
                        }else{
                            this.$message.error("导入菜品库失败:"+(data?.message||""));
                        }
                    })
                }else{
                    loading.close();
                    this.$message.warning('没有需要导入的菜品!');
                    return;
                }
        
            }).catch(e=>{
                loading.close();
                this.$message.error("未加载到菜品数据:"+(e?.message||""));
                console.log('未找到菜品数据:',e)
            });
        },
        /**保存配置 */
        saveConfig(){
            let data={
                isBarcodeScale:this.isBarcodeScale,
                foodCodeStartIndex:this.foodCodeStartIndex,
                foodCodeLength:this.foodCodeLength,
                foodNumberStartIndex:this.foodNumberStartIndex,
                foodNumberLength:this.foodNumberLength,
                foodDecimal:this.foodDecimal||0,
                ip:this.ip
            }
            if(data.isBarcodeScale){
                if(!(data.foodCodeStartIndex>0)){
                    this.$message.warning("请输入菜品编码开始位置!");
                    return;
                }
                if(!(data.foodCodeLength>0)){
                    this.$message.warning("请输入菜品编码长度!");
                    return;
                }

                if(!(data.foodNumberStartIndex>0)){
                    this.$message.warning("请输入菜品数量开始位置!");
                    return;
                }
                if(!(data.foodNumberLength>0)){
                    this.$message.warning("请输入菜品数量长度!");
                    return;
                }

                if(data.foodCodeStartIndex>=data.foodNumberStartIndex && data.foodCodeStartIndex<data.foodNumberStartIndex+data.foodNumberLength){
                    this.$message.warning("菜品编码与菜品数量截取区域重叠!");
                    return;
                }
                if(data.foodCodeStartIndex<=data.foodNumberStartIndex && data.foodCodeStartIndex+data.foodCodeLength>data.foodNumberStartIndex){
                    this.$message.warning("菜品编码与菜品数量截取区域重叠!");
                    return;
                }
                if(data.foodDecimal>=data.foodNumberLength){
                    this.$message.warning("菜品数量小数位必须小于菜品数量长度!");
                    return;
                }

                if(data.ip){
                    if(!/^(([1-9]?\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}([1-9]?\d|1\d{2}|2[0-4]\d|25[0-5])$/.test(data.ip)){
                        this.$message.warning('设备IP地址格式不正确！');
                        return;
                    }
                }
                
            }else{
                data={
                    isBarcodeScale:this.isBarcodeScale,
                }
            }

            
            this.$webBrowser.saveBarcodeScale(data).then(d=>{
                if(d && d.state==0){
                    this.$global.barcodeScaleInfo=data;
                    this.$message.success("保存成功");
                }
            });
        }
    }
}
</script>

<style lang="scss">
@import './barcodeScaleSetup.scss';
</style>